import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Box, FormControlLabel, IconButton, Stack, Typography } from '@mui/material';

import { CommonReasons } from '@modules/ContactManager/components/Header/interfaces';
import { StyledReasonCheckbox, WorkflowReasonCard } from '@styles/ContactManager/WorkflowDetailsStyles';
import { HeaderWrapper } from '@styles/DealSheet/DealSheetStyles';
import { Loader } from '@shared/enhancers/withLoader';
import { useUserAccount } from '@shared/hooks/useUserAccount';
import { Roles } from '@shared/constants/constants';

interface IReasonsPopUpProps {
  reasons: CommonReasons[];
  onClose: () => void;
  loading: boolean;
  handleResolveConditions: (item: CommonReasons, checked: boolean, isLC: boolean, isLP: boolean, isConditionLp: boolean) => void;
}

export const ConditionsPopUp = ({ reasons, onClose, loading, handleResolveConditions }: IReasonsPopUpProps) => {
  const { isAdmin, userHasRoles } = useUserAccount();

  const enableLC = isAdmin || userHasRoles([Roles.LC, Roles.LC_LEAD, Roles.LC_MANAGER]);
  const enableLP = isAdmin || userHasRoles([Roles.LP]);

  return (
    <>
      <HeaderWrapper>
        <Typography variant="h4">Conditions</Typography>
        <IconButton size="small" onClick={onClose}>
          <CloseOutlinedIcon />
        </IconButton>
      </HeaderWrapper>
      {loading ?
        <Loader
          color="inherit"
          minHeight='auto'
        />
        : <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <WorkflowReasonCard>
            <Stack direction="row" gap={3} pl="10px">
              <Typography>LC</Typography>
              <Typography pl="2px">LP</Typography>
            </Stack>
            {reasons.map((item) => {
              return (
                <Stack key={item.reasonId} direction="row" gap={2}>
                  <StyledReasonCheckbox
                    checked={item.isResolvedLc}
                    disabled={!enableLC}
                    onChange={(_, checked) => handleResolveConditions(item, checked, checked, !!item.isResolvedLp, false)}
                  />
                  <FormControlLabel
                    disabled={!enableLP}
                    control={
                      <StyledReasonCheckbox
                        checked={item.isResolvedLp}
                        onChange={(_, checked) => handleResolveConditions(item, checked, !!item.isResolvedLc, checked, true)}
                      />}
                    label={
                      <Typography sx={{fontWeight: item.isLcCondition? 'bold':'regular' }}>{item.label} {item.description ? `: ${item.description}` : ''}</Typography>
                    }
                  />
                </Stack>
              );
            })}
          </WorkflowReasonCard>
        </Box>
      }
    </>
  );
};